import React from "react";
import { Control, Controller } from "react-hook-form";
import PermissionPicker from "components/shared/PermissionPicker";
import Label from "components/shared/form/Label";

export default function PermissionPickerField({
  control,
  name,
  hint,
  label,
}: {
  name: string;
  label?: string;
  hint?: string;
  control: Control<any>;
}) {
  return (
    <div className="control-group">
      {label && <Label label={label} />}
      <div className="controls">
        <Controller
          name={name}
          control={control}
          render={({ field }) => <PermissionPicker {...field} />}
        />
        {hint && <span className="text-muted text-sm">{hint}</span>}
      </div>
    </div>
  );
}
